import { transactionsApi } from 'entities/transactions';
import { toast } from 'react-toastify';
import { bonusStatisticsUrlConfig } from 'entities/bonusStatistics';
import { getTransactionsUrlConfig } from 'features/userTransactions/lib/helpers';
import {
  getBonusesStatisticsQueryType,
  getProfileWalletBalanceQueryType,
  GetTransactionQueryType,
  getUserBalanceQueryType,
  IBalanceItem,
  IBonusStatisticsList,
  ITransactionList,
} from 'features/userTransactions/types';

const getTransactionsApi = transactionsApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query<ITransactionList, GetTransactionQueryType>({
      query: ({ user_id, app_type, page, size, search }) => ({
        url: getTransactionsUrlConfig({ user_id, app_type, page, size, search }),
      }),
      providesTags: ['Transactions'],
    }),
    getUserBalance: builder.query<IBalanceItem[], getUserBalanceQueryType>({
      query: ({ user_id, app_type }) => ({
        url: `/wallet/admin/${app_type}/accounts/${user_id}`,
      }),
      providesTags: ['Transactions'],
    }),
    getProfileWalletBalance: builder.query<{ balance: number }, getProfileWalletBalanceQueryType>({
      query: ({ user_id, wallet_app_type }) => ({
        url: `/wallet/admin/wallet/?user_id=${user_id}&wallet_app_type=${wallet_app_type}`,
      }),
      providesTags: ['Transactions'],
    }),
    getBonusesStatistics: builder.query<IBonusStatisticsList, getBonusesStatisticsQueryType>({
      query: (params) => ({
        url: bonusStatisticsUrlConfig(params),
        method: 'GET',
      }),
      providesTags: ['BonusPromo'],
    }),
    getBonusesStatisticsById: builder.query({
      query: ({ id }) => ({
        url: `/wallet/admin/transactions/${id}/`,
      }),
      providesTags: ['Transactions'],
    }),
    updateBonusStatisticsStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/wallet/admin/transactions/${id}/`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили статус', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['Transactions'];
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetTransactionsQuery,
  useGetUserBalanceQuery,
  useGetProfileWalletBalanceQuery,
  useGetBonusesStatisticsQuery,
  useGetBonusesStatisticsByIdQuery,
  useUpdateBonusStatisticsStatusMutation,
} = getTransactionsApi;
